(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/utils/date/assets/javascripts/helpers/handlebarhelper.js') >= 0) return;  svs.modules.push('/components/utils/date/assets/javascripts/helpers/handlebarhelper.js');

(function() {
  'use strict';

  if (svs.isServer) {
    svs = svs || {};
    svs.utils = svs.utils || {};
    registerHelpers(require('hbs'));
    svs.utils.date = require('../date.es6');
  } else {
    registerHelpers(Handlebars);
  }

  function registerHelpers(hbs) {
    hbs.registerHelper('timePart', function(date) {
      return svs.utils.date.SimpleTime(date);
    });

    hbs.registerHelper('shortDateAndTime', function(date, alwaysDate, useTime) {
      return svs.utils.date.ShortDateAndTime(date, alwaysDate, useTime);
    });

    hbs.registerHelper('formatDateAndTime', function(date) {
      return svs.utils.date.getWeekdayAndTime(date);
    });

    hbs.registerHelper('gameDate', function(dateString) {
      return svs.utils.date.ShortDateAndTime(dateString, false, arguments[1] || false);
    });

    hbs.registerHelper('formatTime', function(format, date) {
      return svs.utils.date.FormatTime(format, date);
    });

    hbs.registerHelper('calendarTime', function(date, showTime, showTodayAsText) {
      if (showTime === null && showTime === undefined) {
        showTime = true;
      }

      if (typeof showTodayAsText !== 'boolean') {
        showTodayAsText = false;
      }

      if (date !== null && date !== undefined) {
        var formattedDate = svs.utils.date.getLocalizedWeekday(date);
        if (showTime) {
          if (!showTodayAsText && formattedDate.substring(0, 4) === 'Idag') {
            formattedDate = svs.utils.date.SimpleTime(date);
          } else {
            formattedDate += ', ' + svs.utils.date.SimpleTime(date);
          }
        } else {
          formattedDate = formattedDate.split(',')[0];
        }
        return formattedDate;
      }

      return false;
    });

    hbs.registerHelper('formatTimeISO', function(format, date) {
      return svs.utils.date.FormatTimeISO(format, date);
    });
  }
})();


 })(window);